import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchAdminDevice = async (deviceId, deviceData) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/devices/${deviceId}`,
    body: deviceData,
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
